{
	"emptyProductFeatureForm": {
		"title": "No functionality model selected",
		"description": "Select a custom product information template. To create a new model, access the",
		"link": "product functionality models."
	}
}
